import {AppConfigExtended, AssessmentMode, ValidationErrorTypes, VerifySetUpCodeResponse, Views, ValidationState, NetworkConnectionState, ManifestProps, Battery, IADPState, PreCacheVaidationStatus, ServiceWorkerType, StressTest, NetworkConnectionStateObj, assessmentLocation, UpdateComponents} from "../types";
import * as actionTypes from "../types/ActionTypes";
import { IpcMessageType } from "../types/BridgeTypes";
import { ValidationResponse} from "@npd-ng/adp-types";
interface UIAction<T = void> {
    type: string;
    payload?: T;
  }
  
  export function createSetConfigAction(
    payload: AppConfigExtended
  ): ISetConfigAction {
    return {
      type: actionTypes.SET_CONFIG,
      payload,
    };
  }
  export function createSetStressTestAction(
    payload: StressTest
  ): ISetStressTestAction {
    return {
      type: actionTypes.SET_STRESS_TEST_ACTION,
      payload,
    };
  }
  export interface ISetStressTestAction extends UIAction<StressTest> {
    type: typeof actionTypes.SET_STRESS_TEST_ACTION;
    payload: StressTest;
  }
  export function createSetContentAction(
    payload: Record<string, unknown>
  ): ISetContentAction {
    return {
      type: actionTypes.SET_CONTENT,
      payload,
    };
  }
  export function createSetSessionDetailsAction(
    payload: Record<string, unknown>
  ): ISetSesssionDetailsAction {
    return {
      type: actionTypes.SET_SESSION_DETAILS,
      payload,
    };
  }
  export function createSetBatteryAction(
    payload: Battery
  ): ISetBatteryAction {
    return {
      type: actionTypes.SET_BATTERY,
      payload,
    };
  }
  //SET_ASSESSMENT_MODE
  export function createSetAssessmentModeAction(
    payload: AssessmentMode
  ): ISetAssessmentModeAction {
    return {
      type: actionTypes.SET_ASSESSMENT_MODE,
      payload,
    };
  }
  export function createSetSelectedLocaleAction(
    payload: Record<string, unknown>
  ): ISetSelectedLocaleAction {
    return {
      type: actionTypes.SET_LOCALE,
      payload,
    };
  }
  export function createSetReleaseVersionAction(
    payload: ManifestProps
  ): ISetReleaseVersion {
    return {
      type: actionTypes.SET_RELEASE_VERSION,
      payload,
    };
  }
  //
  export function createSetBatteryWarningAction(
    payload: Record<string, boolean>
  ): ISetBatteryWarnAction {
    return {
      type: actionTypes.SET_BATTERY_WARN,
      payload,
    };
  }
  export function createSetNetworkAction(
    payload: NetworkConnectionState
  ): ISetNetworkAction {
    return {
      type: actionTypes.SET_NETWORK,
      payload,
    };
  }
  export function createSetNetworkDetails(
    payload: NetworkConnectionStateObj
  ): ISetNetworkDetailsAction {
    return {
      type: actionTypes.SET_NETWORK_DETAILS,
      payload,
    };
  }
  export function createUpdateNCSConfigAction(
    payload: IADPState["connectedNCSState"]
  ): IUpdateNCSConfigAction {
    return {
      type: actionTypes.UPDATE_NCS_STATE,
      payload,
    };
  }
  export function createSetViewAction(
    payload: Views
  ): ISetSetViewAction {
    return {
      type: actionTypes.SET_VIEW,
      payload,
    };
  }
  export function createUpdateSchoolAction(
    payload: VerifySetUpCodeResponse | undefined
  ): IUpdateSchoolAction {
    return {
      type: actionTypes.UPDATE_SCHOOL,
      payload,
    };
  }
  export function createValidationAction(
    payload: ValidationState
  ): ISetValidationAction {
    return {
      type: actionTypes.SET_VALIDATION_ACTION,
      payload,
    };
  }
  export function createSetUpdateComponentVersionsAction(
    payload: UpdateComponents
  ): ISetUpdateComponentVersionsAction {
    return {
      type: actionTypes.SET_APP_COMPONENT_VERSIONS,
      payload,
    };
  }

  export interface ISetUpdateComponentVersionsAction extends UIAction<UpdateComponents> {
    type: typeof actionTypes.SET_APP_COMPONENT_VERSIONS;
    payload: UpdateComponents;
  }

  export function createUpdateProgressAction(
    payload: IpcMessageType
  ): ISetUpdateProgressAction {
    return {
      type: actionTypes.SET_UPDATE_PROGRESS,
      payload,
    };
  }
  export function createWarningAction(
    payload: ValidationErrorTypes
  ): IShowWarningAction {
    return {
      type: actionTypes.SHOW_WARNING_ACTION,
      payload,
    };
  }
  export function createErrorAction(
    payload: ValidationErrorTypes
  ): IShowErrorAction {
    return {
      type: actionTypes.SHOW_ERROR_ACTION,
      payload,
    };
  }
  export function createNoUpdatesAction(
    payload: boolean
  ): ISetNoUpdates {
    return {
      type: actionTypes.SET_APP_LATEST,
      payload,
    };
  }
  export function createUpdateDeviceValidationStateAction(
    payload: IADPState["deviceReadinessState"]["deviceReadinessInfo"]
  ): IUpdateDeviceValidationState {
    return {
      type: actionTypes.UPDATE_DEVICE_VALIDATION_STATE,
      payload,
    };
  }
  export function createUpdateServiceWorkerDetailsAction(
    payload: ServiceWorkerType
  ): IUpdateServiceWorkerDetails {
    return {
      type: actionTypes.UPDATE_SERVICE_WORKER_DETAILS,
      payload,
    };
  }
  export function createSetDeviceReadinessSummary(
    payload: ValidationResponse[]
  ): IcreateSetDeviceReadinessSummary {
    return {
      type: actionTypes.SET_DEVICE_READINESS_SUMMARY,
      payload,
    };
  }
  export interface IcreateSetDeviceReadinessSummary extends UIAction<ValidationResponse[]> {
    type: typeof actionTypes.SET_DEVICE_READINESS_SUMMARY;
    payload: ValidationResponse[];
  }
  export function createUpdatePreChacheValidationStatusAction(
    payload: PreCacheVaidationStatus
  ): IUpdatePreChacheValidationStatus {
    return {
      type: actionTypes.UPDATE_PRECACHE_VALIDATION_STATUS,
      payload,
    };
  }
  export function createSetAssessmentLocationAction(
    payload: assessmentLocation | undefined
  ): ISetAssessmentLocationAction {
    return {
      type: actionTypes.SET_ASSESSMENT_LOCATION,
      payload,
    };
  }
  export interface ISetAssessmentLocationAction extends UIAction<assessmentLocation | undefined> {
    type: typeof actionTypes.SET_ASSESSMENT_LOCATION;
    payload: assessmentLocation | undefined;
  }
  export function createLocationErrorAction(
    payload: boolean
  ): ISetLocationErrorAction {
    return {
      type: actionTypes.SET_LOCATION_ERROR,
      payload,
    };
  }
  export interface ISetLocationErrorAction extends UIAction<boolean> {
    type: typeof actionTypes.SET_LOCATION_ERROR;
    payload: boolean;
  }
  
  export interface IUpdatePreChacheValidationStatus extends UIAction<PreCacheVaidationStatus> {
    type: typeof actionTypes.UPDATE_PRECACHE_VALIDATION_STATUS;
    payload: PreCacheVaidationStatus;
  }
  export interface IUpdateServiceWorkerDetails extends UIAction<ServiceWorkerType> {
    type: typeof actionTypes.UPDATE_SERVICE_WORKER_DETAILS;
    payload: ServiceWorkerType;
  }
  export interface ISetConfigAction extends UIAction<AppConfigExtended> {
    type: typeof actionTypes.SET_CONFIG;
    payload: AppConfigExtended;
  }
  export interface ISetContentAction extends UIAction<Record<string, unknown>> {
    type: typeof actionTypes.SET_CONTENT;
    payload: Record<string, unknown>;
  }
  export interface ISetBatteryAction extends UIAction<Battery> {
    type: typeof actionTypes.SET_BATTERY;
    payload: Battery;
  }
  export interface ISetBatteryWarnAction extends UIAction<Record<string, unknown>> {
    type: typeof actionTypes.SET_BATTERY_WARN;
    payload: Record<string, unknown>;
  }
  export interface ISetNetworkAction extends UIAction<NetworkConnectionState> {
    type: typeof actionTypes.SET_NETWORK;
    payload: NetworkConnectionState;
  }
  export interface ISetNetworkDetailsAction extends UIAction<NetworkConnectionStateObj> {
    type: typeof actionTypes.SET_NETWORK_DETAILS;
    payload: NetworkConnectionStateObj;
  }
  export interface IUpdateNCSConfigAction extends UIAction<IADPState["connectedNCSState"]> {
    type: typeof actionTypes.UPDATE_NCS_STATE;
    payload: IADPState["connectedNCSState"];
  }
  export interface ISetTimeAction extends UIAction<Record<string, unknown>> {
    type: typeof actionTypes.SET_TIME;
    payload: Record<string, unknown>;
  }
  export interface ISetSelectedLocaleAction extends UIAction<Record<string, unknown>> {
    type: typeof actionTypes.SET_LOCALE;
    payload: Record<string, unknown>;
  }
  
  export interface ISetSesssionDetailsAction extends UIAction<Record<string, unknown>> {
    type: typeof actionTypes.SET_SESSION_DETAILS;
    payload: Record<string, unknown>;
  }
  
  export interface ICheckForUpdateAction extends UIAction<Record<string, unknown>> {
    type: typeof actionTypes.CHECK_FOR_UPDATE;
    payload: Record<string, unknown>;
  }
  export interface ISetUpdateProgressAction extends UIAction<IpcMessageType> {
    type: typeof actionTypes.SET_UPDATE_PROGRESS;
    payload: IpcMessageType;
  }

  export interface ISetSetViewAction extends UIAction<Views> {
    type: typeof actionTypes.SET_VIEW;
    payload: Views;
  }

  export interface ISetAssessmentModeAction extends UIAction<AssessmentMode> {
    type: typeof actionTypes.SET_ASSESSMENT_MODE;
    payload: AssessmentMode;
  }

  export interface IUpdateSchoolAction extends UIAction<VerifySetUpCodeResponse> {
    type: typeof actionTypes.UPDATE_SCHOOL;
    payload: VerifySetUpCodeResponse | undefined;
  }
  
  export interface ISetValidationAction extends UIAction<ValidationState> {
    type: typeof actionTypes.SET_VALIDATION_ACTION;
    payload: ValidationState
  }

  export interface IShowWarningAction extends UIAction<ValidationErrorTypes> {
    type: typeof actionTypes.SHOW_WARNING_ACTION;
    payload: ValidationErrorTypes
  }

  export interface IShowErrorAction extends UIAction<ValidationErrorTypes> {
    type: typeof actionTypes.SHOW_ERROR_ACTION;
    payload: ValidationErrorTypes
  }
  export interface ISetNoUpdates extends UIAction<boolean> {
    type: typeof actionTypes.SET_APP_LATEST
    payload: boolean
  }
  export interface ISetReleaseVersion extends UIAction<ManifestProps> {
    type: typeof actionTypes.SET_RELEASE_VERSION
    payload: ManifestProps
  }
  export interface IUpdateDeviceValidationState extends UIAction<IADPState["deviceReadinessState"]["deviceReadinessInfo"]> {
    type: typeof actionTypes.UPDATE_DEVICE_VALIDATION_STATE
    payload: IADPState["deviceReadinessState"]["deviceReadinessInfo"]
  }
  //
  export type IADPActions =
  | ISetConfigAction
  | ISetContentAction
  | ISetSesssionDetailsAction
  | ICheckForUpdateAction
  | ISetUpdateProgressAction
  | ISetSetViewAction
  | ISetAssessmentModeAction
  | IUpdateSchoolAction
  | ISetValidationAction
  | IShowWarningAction
  | IShowErrorAction
  | ISetNoUpdates
  | ISetNetworkAction
  | ISetReleaseVersion
  | ISetBatteryAction
  | IUpdateDeviceValidationState
  | IUpdateServiceWorkerDetails
  | IUpdatePreChacheValidationStatus
  | IUpdateNCSConfigAction
  | ISetStressTestAction
  | IcreateSetDeviceReadinessSummary
  | ISetNetworkDetailsAction
  | ISetAssessmentLocationAction
  | ISetLocationErrorAction
  | ISetUpdateComponentVersionsAction
  
  export type IADPHeaderActions = 
  | ISetBatteryAction
  | ISetNetworkAction
  | ISetTimeAction
  | ISetBatteryWarnAction
  | ISetSelectedLocaleAction
  
  